import type { SidebarNavLinks, SidebarLinksBottom } from "./types";

import { ReactComponent as ProfileIcon } from "assets/icons/new/Profile/Account.svg";
import { ReactComponent as BalanceIcon } from "assets/icons/new/Profile/Balance.svg";
import { ReactComponent as DocumentsIcon } from "assets/icons/new/Profile/FinancialBriefcase.svg";
import { ReactComponent as HistoryIcon } from "assets/icons/new/Profile/WoodenStamp.svg";

import { ReactComponent as marketplaces } from "assets/icons/new/Chapters/Channels.svg";
import { ReactComponent as settings } from "assets/icons/new/Chapters/Settings.svg";
import { ReactComponent as addProducts } from "assets/icons/new/Chapters/Products.svg";
import { ReactComponent as priceList } from "assets/icons/new/Chapters/Offers.svg";
import { ReactComponent as warehouse } from "assets/icons/new/Chapters/Warehouses.svg";
import { ReactComponent as Overview } from "assets/icons/new/Chapters/Overview.svg";
import { ReactComponent as orders } from "assets/icons/new/Chapters/Orders.svg";
import { ReactComponent as analytics } from "assets/icons/new/Chapters/Analytics.svg";
import { ReactComponent as finances } from "assets/icons/cardIcons/Finances.svg"
import { ReactComponent as shipment } from "assets/icons/new/Chapters/Shipments.svg"
import { ReactComponent as tools } from "assets/icons/new/Chapters/Tools.svg"
import { ReactComponent as reviews } from "assets/icons/new/Chapters/Reviews.svg"
import { ReactComponent as product_packaging } from "assets/icons/new/Chapters/Inventory.svg"

export const sidebarNavLinks: SidebarNavLinks = [
    {
        path: "/",
        name: "home",
        Icon: Overview
    },
    {
        path: "/marketplaces",
        name: "markets",
        Icon: marketplaces,
    },
    {
        path: "/pim",
        name: "products",
        Icon: addProducts,
    },
    {
        path: "/offers",
        name: "prices",
        Icon: priceList,
    },
    {
        path: "/stocks-fbs",
        name: "remains",
        Icon: product_packaging,
    },
    {
        path: "/orders",
        name: "Orders",
        Icon: orders,
    },
    {
        path: "/warehouses",
        name: "warehouses",
        Icon: warehouse,
    },
    {
        path: "/shipments",
        name: "shipments_sidebar",
        Icon: shipment,
    },
    {
        path: "/analytics",
        name: "analytics",
        Icon: analytics,
    },
    {
        path: "/ai-reviews",
        name: "ai-reviews",
        Icon: reviews
    },
    {
        path: "/home/tools",
        name: "Tools",
        Icon: tools,
    },
    {
        path: "/seller/edit/:id",
        name: "settings",
        Icon: settings,
    }
]

export const sidebarBottomLinks: SidebarLinksBottom = [
    {
        path: "https://lk.market/legal/privacy",
        name: "Privacy policy",
        externalLink: true
    },
    {
        path: "https://lk.market/legal/terms",
        name: "User agreement",
        externalLink: true
    },
    {
        path: "/welcome/service-agreement",
        name: "business_offer",
        externalLink: false
    }
]

export const sidebarAccountLinks = [
    {
        path: "/profile",
        name: "profile_settings",
        Icon: ProfileIcon,
        noSellerId: true
    },
    {
        path: "/billing/plans",
        name: "account_balance",
        Icon: BalanceIcon,
        noSellerId: true
    },
    {
        path: "/billing/documents",
        name: "BillsAndDocuments",
        Icon: DocumentsIcon,
        noSellerId: true
    },
    {
        path: "/billing/history",
        name: "OperationsHistory",
        Icon: HistoryIcon,
        noSellerId: true
    },
    // {
    //     path: "/#",
    //     name: "AccountSettings",
    //     Icon: settings
    // },
    // {
    //     path: "/#",
    //     name: "PlanPay",
    //     Icon: settings
    // },
    // {
    //     path: "/#",
    //     name: "TopUpBalance",
    //     Icon: settings
    // },
    // {
    //     path: "/#",
    //     name: "BillsAndDocuments",
    //     Icon: settings
    // },
    // {
    //     path: "/#",
    //     name: "OperationsHistory",
    //     Icon: settings
    // },
    // {
    //     path: "/#",
    //     name: "OrderedServices",
    //     Icon: settings
    // }
]